function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoPanther = function SvgLogoPanther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360.933 85.418"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 5.238-3.645 8.047-9.489 8.047h-9.034V-8.199h9.261C-3.417-8.199 0-4.707 0-.152zm-9.642-18.6h-8.881v-15.942h-11.692V18.6h21.712c12.678 0 20.346-7.517 20.346-18.371V.077c0-12.3-9.566-18.677-21.485-18.677",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 68.59 10.743)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.974.91-4.555 1.518-7.364 1.518-4.934 0-7.971-1.974-7.971-5.618v-.151c0-3.113 2.582-4.935 6.301-4.935C-3.644-9.186 0-6.225 0-2.049zm-.228-16.398v4.402c-2.808-3.111-6.681-5.162-12.298-5.162-7.667 0-13.969 4.404-13.969 12.451v.152c0 8.883 6.757 12.981 16.398 12.981 4.099 0 7.061-.683 9.945-1.67v.683c0 4.784-2.96 7.441-8.73 7.441-4.404 0-7.516-.835-11.236-2.201l-2.885 8.805c4.48 1.974 8.882 3.265 15.791 3.265 12.602 0 18.144-6.529 18.144-17.537v-23.61z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 85.42 17.913)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v22.698c0 5.467-2.582 8.276-6.985 8.276-4.403 0-7.212-2.809-7.212-8.276V0h-11.539v40.691h11.539v-5.77c2.657 3.417 6.074 6.529 11.92 6.529 8.73 0 13.816-5.769 13.816-15.108V0Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 103.84 24.393)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.061 0-11.843 2.81-11.843 12.223v19.282h-4.859v9.87h4.859v10.4H-.304v-10.4h9.565v-9.87H-.304V14.12c0-2.657 1.139-3.947 3.72-3.947 2.126 0 4.023.532 5.693 1.442V2.354C6.68.911 3.872 0 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 117.788 24.664)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v22.698c0 5.467-2.582 8.276-6.985 8.276-4.403 0-7.212-2.809-7.212-8.276V0h-11.539v55.419h11.539V34.921c2.657 3.417 6.074 6.529 11.92 6.529 8.73 0 13.817-5.769 13.817-15.108V0Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 134.977 24.393)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-4.783 0-7.895-3.416-8.806-8.655H8.579C7.896-3.492 4.859 0 0 0m19.663-15.867H-8.654c1.139-5.237 4.782-7.97 9.944-7.97 3.872 0 6.681 1.214 9.87 4.175l6.605-5.845c-3.796-4.707-9.263-7.592-16.627-7.592-12.221 0-21.256 8.578-21.256 21.029v.152c0 11.614 8.275 21.18 20.118 21.18 13.589 0 19.814-10.553 19.814-22.091v-.152c0-1.139-.076-1.822-.151-2.886",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 150.666 11.673)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.667 0-12.375-4.63-12.375-14.347v-15.032h-11.539v40.691h11.539V3.113c2.354 5.617 6.149 9.262 12.981 8.958V0Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 171.335 12.783)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ccc",
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 3.746-2.6 6.15-5.591 6.15-2.963 0-5.814-2.488-5.814-6.122v-.055c0-3.662 2.851-6.122 5.814-6.122C-2.488-6.149 0-3.886 0-.056zm-5.451-7.464c-2.852 0-4.696 1.622-5.87 3.411v-7.548h-1.37v18.73h1.37V3.942c1.229 1.872 3.047 3.522 5.87 3.522 3.438 0 6.932-2.768 6.932-7.407V0c0-4.64-3.494-7.464-6.932-7.464",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 189.086 79.556)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ccc",
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.202.307-2.796.643-4.837.643-3.018 0-4.696-1.342-4.696-3.327v-.056c0-2.069 1.957-3.271 4.137-3.271C-2.488-6.011 0-4.222 0-1.622zm-.028-6.961v2.376c-.979-1.37-2.74-2.712-5.451-2.712-2.656 0-5.507 1.51-5.507 4.473v.056c0 2.963 2.544 4.641 6.233 4.641 1.985 0 3.355-.252 4.725-.615v.615c0 2.879-1.761 4.36-4.697 4.36-1.733 0-3.159-.475-4.472-1.146L-9.7 6.289c1.565.727 3.102 1.231 5.059 1.231 3.662 0 5.954-1.902 5.954-5.591v-8.89z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 195.24 79.622)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ccc",
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v8.47c0 2.935-1.649 4.864-4.529 4.864-2.795 0-4.948-2.124-4.948-5.088V0h-1.37v14.257h1.37v-2.656c.951 1.677 2.544 2.991 5.144 2.991 3.605 0 5.702-2.46 5.702-5.87V0Z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 201.991 82.373)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ccc",
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2.208 0-3.997 1.202-3.997 3.914v9.337h-2.068v1.258h2.068v4.556h1.37v-4.556h5.003v-1.258h-5.003V4.054c0-2.041 1.202-2.768 2.851-2.768.699 0 1.286.14 2.096.503V.504A5.222 5.222 0 0 0 0 0",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 206.355 82.472)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ccc",
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v8.47c0 2.935-1.649 4.864-4.529 4.864-2.795 0-4.948-2.124-4.948-5.088V0h-1.37v20.406h1.37v-8.805c.951 1.677 2.544 2.991 5.144 2.991 3.605 0 5.702-2.46 5.702-5.87V0Z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 213.183 82.373)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ccc",
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.196 2.88-1.846 5.535-5.116 5.535-2.823 0-5.004-2.376-5.255-5.535Zm-4.78-6.849c2.208 0 3.718.979 4.891 2.237l.951-.839C-.392-7.016-2.097-8.135-4.836-8.135c-3.746 0-6.989 2.991-6.989 7.437v.055c0 4.137 2.907 7.436 6.764 7.436 3.999 0 6.542-3.242 6.542-7.464v-.056c0-.195 0-.279-.028-.502h-11.824c.251-3.55 2.795-5.62 5.591-5.62",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 219.955 79.29)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ccc",
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-3.299 0-6.178-2.488-6.178-7.128v-5.843h-1.37V1.286h1.37v-4.054C-5.06-.224-2.684 1.621.14 1.51V0Z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 225.104 77.247)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ccc",
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-5.591 0-9.728 4.445-9.728 10.064v.056c0 5.534 4.137 10.119 9.784 10.119 3.495 0 5.59-1.286 7.603-3.131l-1.034-1.062c-1.705 1.649-3.662 2.88-6.597 2.88-4.696 0-8.247-3.83-8.247-8.75v-.056c0-4.948 3.607-8.806 8.275-8.806 2.823 0 4.753 1.09 6.737 3.047l.978-.95C5.703 1.37 3.467 0 0 0",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 230.163 82.506)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ccc",
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 3.438-2.572 6.179-5.871 6.179-3.382 0-5.815-2.768-5.815-6.122V0c0-3.438 2.573-6.178 5.872-6.178C-2.433-6.178 0-3.41 0-.056zm-5.871-7.464c-4.221 0-7.296 3.411-7.296 7.408V0c0 3.998 3.104 7.464 7.353 7.464 4.22 0 7.295-3.41 7.295-7.407V0c0-3.997-3.103-7.464-7.352-7.464",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 239.4 79.556)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ccc",
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v8.47c0 2.935-1.649 4.864-4.529 4.864-2.795 0-4.948-2.124-4.948-5.088V0h-1.37v14.257h1.37v-2.656c.951 1.677 2.544 2.991 5.144 2.991 3.605 0 5.702-2.46 5.702-5.87V0Z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 245.94 82.373)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ccc",
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v8.47c0 2.935-1.649 4.864-4.529 4.864-2.795 0-4.948-2.124-4.948-5.088V0h-1.37v14.257h1.37v-2.656c.951 1.677 2.544 2.991 5.144 2.991 3.605 0 5.702-2.46 5.702-5.87V0Z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 252.713 82.373)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ccc",
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.196 2.88-1.846 5.535-5.116 5.535-2.823 0-5.004-2.376-5.255-5.535Zm-4.78-6.849c2.208 0 3.718.979 4.891 2.237l.951-.839C-.392-7.016-2.097-8.135-4.837-8.135c-3.745 0-6.988 2.991-6.988 7.437v.055c0 4.137 2.907 7.436 6.765 7.436 3.998 0 6.541-3.242 6.541-7.464v-.056c0-.195 0-.279-.028-.502h-11.824c.251-3.55 2.795-5.62 5.591-5.62",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 259.485 79.29)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ccc",
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-4.109 0-7.269 3.411-7.269 7.408v.056c0 3.998 3.187 7.464 7.269 7.464 2.684 0 4.36-1.23 5.702-2.627l-.978-1.007c-1.23 1.258-2.627 2.349-4.752 2.349-3.243 0-5.759-2.712-5.759-6.122v-.057c0-3.439 2.599-6.178 5.871-6.178 2.013 0 3.578 1.034 4.779 2.376l.951-.838C4.36 1.175 2.627 0 0 0",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 264.137 82.506)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ccc",
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2.208 0-3.997 1.202-3.997 3.914v9.337h-2.068v1.258h2.068v4.556h1.37v-4.556h5.003v-1.258h-5.003V4.054c0-2.041 1.202-2.768 2.851-2.768.699 0 1.286.14 2.096.503V.504A5.222 5.222 0 0 0 0 0",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 269.837 82.472)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M272.258 81.434h.73v.939h-.73z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.39518577
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ccc",
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v8.47c0 3.075-1.593 4.864-4.221 4.864-2.404 0-4.501-1.845-4.501-5.031V0h-1.369v8.554c0 2.964-1.622 4.78-4.165 4.78-2.544 0-4.556-2.236-4.556-5.115V0h-1.371v14.257h1.371v-2.544c.921 1.481 2.208 2.879 4.751 2.879 2.489 0 4.026-1.426 4.809-3.074.922 1.592 2.459 3.074 5.143 3.074 3.382 0 5.479-2.376 5.479-5.954V0Z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 282.896 82.373)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ccc",
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.196 2.88-1.846 5.535-5.116 5.535-2.823 0-5.004-2.376-5.255-5.535Zm-4.78-6.849c2.208 0 3.718.979 4.891 2.237l.951-.839C-.392-7.016-2.097-8.135-4.837-8.135c-3.745 0-6.988 2.991-6.988 7.437v.055c0 4.137 2.907 7.436 6.765 7.436 3.998 0 6.541-3.242 6.541-7.464v-.056c0-.195 0-.279-.028-.502h-11.824c.251-3.55 2.795-5.62 5.591-5.62",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 289.713 79.29)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-18.337h27.506v-72.055h19.886v72.055h27.504V0Z",
    style: {
      fill: "#047de7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 270.394 31.36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-15.496 0-26.214 12.914-26.214 28.41v.258c0 15.495 10.977 28.15 26.214 28.15 9.04 0 16.141-3.873 23.114-10.202l12.655 14.593C27.375 69.474 17.174 75.155.129 75.155c-27.763 0-47.132-21.048-47.132-46.745v-.258c0-25.955 19.756-46.489 46.357-46.489 17.433 0 27.764 6.198 37.061 16.143L23.76 10.589C16.658 4.133 10.331 0 0 0",
    style: {
      fill: "#047de7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 71.785 60.448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-15.497-11.105-28.152-27.118-28.152-16.011 0-27.375 12.914-27.375 28.41v.258c0 15.495 11.105 28.15 27.118 28.15C-11.363 28.666 0 15.753 0 .258Zm20.79.258v.258c0 25.697-20.016 46.486-47.908 46.486-27.892 0-48.165-21.047-48.165-46.744V0c0-25.697 20.015-46.489 47.908-46.489C.517-46.489 20.79-25.439 20.79.258",
    style: {
      fill: "#047de7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 119.598 49.323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-34.867-23.245L9.183-4.032h10.445v18.79L0 .056Z",
    style: {
      fill: "#047de7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 135.283 65.728)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 16.575 9.437-28.072 36.888h-18.336v-59.819l-18.953-13.412 9.519 4.551 9.434 5.371 19.628 11.173.798.456-.798-.091v18.841z",
    style: {
      fill: "#047de7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 147.073 49.906)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-18.337v-29.403l28.406 16.172z",
    style: {
      fill: "#047de7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 166.486 31.36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h42.613v17.69H0v18.337h48.425v17.691h-68.182v-90.392h68.826v17.691H0Z",
    style: {
      fill: "#047de7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 208.148 52.589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-15.496 0-26.213 12.914-26.213 28.41v.258c0 15.495 10.975 28.15 26.213 28.15 9.039 0 16.142-3.873 23.113-10.202L35.77 61.209C27.376 69.474 17.175 75.155.129 75.155c-27.764 0-47.132-21.048-47.132-46.745v-.258c0-25.955 19.757-46.489 46.357-46.489 17.434 0 27.764 6.198 37.06 16.143L23.76 10.589C16.657 4.133 10.33 0 0 0",
    style: {
      fill: "#047de7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 251.705 60.448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-27.457-20.566-15.898-11.909-11.202-8.39-4.624-3.464-.072-.054v-14.665l-7.108 9.341-15.126-11.33 25.018-32.84h16.664l.18-.143v.143h.071v46.84l-.071.029v11.198L4.149-93.271h16.917V-.448L1.438-17.226v-41.31l-23.836 31.323 54.984 46.02z",
    style: {
      fill: "#047de7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.39519 0 0 -.39519 182.655 30.222)"
  }));
};
export default SvgLogoPanther;